import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreatePrintKioskDeviceCommand, CreateDeviceRelationshipCommand } from '@shared/models/commands';
import { PrintKiosk } from '@shared/models/print-kiosk.model';

export const PrintKioskActions = createActionGroup({
  source: 'PrintKiosk',
  events: {
    'Reset': emptyProps(),

    'Add': props<{ command: CreatePrintKioskDeviceCommand }>(),
    'Add Success': props<{ printKiosk: PrintKiosk }>(),
    'Add Failure': props<{ error: unknown }>(),

    'Remove': props<{ command: { id: string } }>(),
    'Remove Success': props<{ id: string }>(),
    'Remove Failure': props<{ error: unknown }>(),

    'Link To Printer': props<{ command: CreateDeviceRelationshipCommand }>(),
    'Link To Printer Success': emptyProps(),
    'Link To Printer Failure': props<{ error: unknown }>(),

    'Load': emptyProps(),
    'Load Success': props<{ printKiosks: PrintKiosk[] }>(),
    'Load Failure': props<{ error: unknown }>(),
  },
});
